import React, { useState, useEffect, ChangeEvent, FormEvent, ReactNode } from 'react';
import InputCustom from '../../Components/InputCustom';
import Btn from '../../Components/Btn';
import SpinnerWheel from '../../Components/SpinnerWheel';
import SectionMessage from '../../Components/SectionMessage';
import InstagramServices from '../../Services/InstagramServices';
import SystemServices from '../../Services/SystemServices';

interface InstagramFormProps {
  $http: any;
  $rootScope: any;
  $routeParams: any;
  $timeout:any;
  accountCurrentTab:number;
  accountId: string;
  children?: ReactNode;
}

const InstagramForm: React.FC<InstagramFormProps> = ({
	$http,
	$rootScope,
	$timeout,
	accountCurrentTab,accountId,
}) => {

	const [accessToken, setAccessToken] = useState<string>('');
	const [isLoading, setIsLoading] = useState(false);
	const instagramServices = new InstagramServices(accountId, $http);
	const systemServices = new SystemServices($rootScope, $timeout);

	useEffect(() => {
		if(accountCurrentTab === 10) {
			setIsLoading(true);
			instagramServices.getAccountAccessToken(
				(tokenResponse: any) => {
					const token = typeof tokenResponse === 'object' && tokenResponse !== null
						? tokenResponse.token
						: tokenResponse;
					if (token) {
						setAccessToken(token);
					} else {
						setAccessToken('');
					}
					setIsLoading(false);
				},
				(error: any, _dataError: any) => {
					setIsLoading(false);
					console.error('Error fetching access token:', error);
				}
			);
		}
        
	}, [accountCurrentTab]);

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		setAccessToken(event.target.value);
	};

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setIsLoading(true);
		instagramServices.postAccounAccessToken(
			accessToken,
			() => {
				setIsLoading(false);
				systemServices.showSuccess('Access token submitted successfully');
			},
			(error: any) => {
				setIsLoading(false);
				systemServices.showError('An error occurred while submitting the access token.');
				console.error('Error submitting access token:', error);
			}
		);
	};
    
	return (
		<>
			<div className='mb_20'>
				<div className='s_18 mb_8'>Connect your Instagram account with BEYABLE</div>
				<p className='s_15'>Access your Instagram posts and publish them on your website with BEYABLE campaigns.</p>
			</div>
			<form onSubmit={handleSubmit}>
				{isLoading && <SpinnerWheel wheelSize="l" />}
				<div style={{width: 700}}>
					<SectionMessage>
						To connect your Instagram account, please enter your access token below.<br />
						If you have never connected an account before, retrieve your token using the Instagram documentation.
					</SectionMessage>
					<InputCustom
						label="Instagram access token"
						placeholder="Insert your Instagram access token here"
						id="accessToken"
						value={accessToken}
						onChange={handleChange}
						fullWidth={true}
					/>
				</div>
				<div>
					<Btn
						message={'Save token'}
						type="submit"
					/>
				</div>
			</form>
		</>
	);
};

export default InstagramForm;